import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TypeEventOperationHistory } from "@edp-enums/type-event-operation.enum";
import { SelectedComponentEnum } from "@edp-models/edp-payment-agreement.model";
import { AgreementContactResponse, AgreementContactUSed } from "@edp-models/edp-payment.model";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { NifService } from "@edp-services/nif.service";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { PaymentService } from "@edp-services/payment.service";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { IAppState } from "@edp-store/state/app.state";
import { NifValidator } from "@edp-validators/nif.validator";
import { Store } from "@ngrx/store";

@Component({
    selector: "personal-data-validation",
    templateUrl: "./personal-data-validation.component.html",
    styleUrls: ["./personal-data-validation.component.scss"],
})
export class PersonalDataValidationComponent {
    public form: FormGroup;
    public recaptchaToken = null;
    public recaptcha: any;
    public showNifError = false;
    public nifValue: number = null;
    public nifNotFound: boolean;

    constructor(
        private paymentService: PaymentService,
        private readonly formBuilder: FormBuilder,
        private store: Store<IAppState>,
        private edpPaymentAgreementService: EdpPaymentAgreementService,
        private nifService: NifService
    ) {
        this.form = this.formBuilder.group({
            nif: ["", [Validators.required, NifValidator()]],
        });

        const nifControl = this.form.get("nif");
        nifControl.valueChanges.subscribe(value => {
            this.nifValue = value;
        });
    }

    public submit() {
        const nif = this.form.get("nif").value;
        const args = {
            recaptcha: this.recaptchaToken,
            nif: nif,
        };

        if (nif) {
            this.setOperationHistory(nif, TypeEventOperationHistory.INSERTNIF);
        }

        return this.paymentService.agreementContact(args).subscribe(
            (response: any) => {
                this.setOperationHistory(nif, TypeEventOperationHistory.RESPONSEREQUESTNIF);
                const res: AgreementContactResponse = response[0];
                switch (true) {
                    case res.used === AgreementContactUSed.NOT_FOUND_CONTACT:
                        this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.NO_ASSOCIATED_CONTACT);
                        this.store.dispatch(new ShowLoader(false));
                        return;
                    case res.used === AgreementContactUSed.NOT_FOUND_CUSTOMER:
                        this.nifNotFound = true;
                        this.store.dispatch(new ShowLoader(false));
                        return console.log(res.used);
                    case res.used === AgreementContactUSed.EMAIL || res.used === AgreementContactUSed.MOBILE:
                        this.generateToken();
                        this.nifService.setNifValue(nif);
                        this.edpPaymentAgreementService.setContactResponse(res);
                        this.store.dispatch(new ShowLoader(false));
                        return this.goToTokenValidation();
                }
            },
            error => {
                this.store.dispatch(new ShowLoader(false));
                console.log(error.message);
            }
        );
    }

    public onSubmitClick(captchaRef: any): void {
        const nif = "nif";
        if (this.form.controls[nif].invalid) {
            this.showNifError = true;
        } else {
            captchaRef.execute();
            this.recaptcha = captchaRef;
        }
    }

    public resolved(captchaResponse: string): void {
        this.recaptchaToken = captchaResponse;
        if (this.recaptchaToken) {
            this.store.dispatch(new ShowLoader(true));
            this.submit();
        }
    }

    public goToTokenValidation() {
        return this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.TOKEN);
    }

    public generateToken() {
        const userNif = this.form.get("nif").value;
        const args = {
            nif: userNif,
        };

        /* TODO: RESOLVE ERROR */
        return this.paymentService.generateToken(args).subscribe(() => {
            this.setOperationHistory(userNif, TypeEventOperationHistory.VALIDATETOKEN);
        });
    }

    private setOperationHistory(nif: string, operation: string) {
        this.paymentService.agreementHistory({ nif, operation }).subscribe(() => {});
    }
}
